import type { fabric } from 'fabric';
import React, { useCallback } from 'react';
import CommitNumberField from './shared/commit-number-field';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import { useFabricProp } from './shared/use-fabric-prop';
import type { ObjectInspectorProps } from './types';

const PlaceholderTransformSection: React.FC<ObjectInspectorProps> = ({ object, editor }) => {
  const [left, setLeft] = useFabricProp<number>(object, 'left', editor);
  const [top, setTop] = useFabricProp<number>(object, 'top', editor);
  const [width, setWidth] = useFabricProp<number>(object, 'width', editor);
  const [height, setHeight] = useFabricProp<number>(object, 'height', editor);
  const [angle, setAngle] = useFabricProp<number>(object, 'angle', editor);

  const commitWith = useCallback(
    (setter: (v: number) => void) => (value: number) => {
      setter(value);
      editor.placeholders?.refit(object as fabric.Group);
    },
    [editor, object],
  );

  return (
    <InspectorSection title="Transform">
      <InspectorRow label="X">
        <CommitNumberField value={left} onCommit={commitWith(setLeft)} />
      </InspectorRow>
      <InspectorRow label="Y">
        <CommitNumberField value={top} onCommit={commitWith(setTop)} />
      </InspectorRow>
      <InspectorRow label="Width">
        <CommitNumberField value={width} onCommit={commitWith(setWidth)} min={1} />
      </InspectorRow>
      <InspectorRow label="Height">
        <CommitNumberField value={height} onCommit={commitWith(setHeight)} min={1} />
      </InspectorRow>
      <InspectorRow label="Angle">
        <CommitNumberField value={angle} onCommit={commitWith(setAngle)} step={1} />
      </InspectorRow>
    </InspectorSection>
  );
};

export default PlaceholderTransformSection;
